"use client";

import { c as _c } from "react/compiler-runtime";
import AppWalletImport from "@/components/app-wallets/AppWalletImport";
import { useSetTitle } from "@/contexts/TitleContext";
import styles from "@/styles/Home.module.scss";
export default function AppWalletImportPage() {
  const $ = _c(1);
  useSetTitle("Import App Wallet | Tools");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <main className={styles.main}><AppWalletImport /></main>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}